import fs from 'node:fs'
import path from 'node:path'
import type { ExtensionTemplateReader } from '@cli-types/next-adapter/utils.js'
import { resolveCliAssetPath } from '@cli-utils/paths.js'

export function createExtensionTemplateReader(kindSegment: string): ExtensionTemplateReader {
  function root(id: string): string {
    return resolveCliAssetPath('adapters', 'next', kindSegment, id)
  }

  return {
    root,
    read(id, relativePath) {
      // Resolve against the extension root, then re-resolve the joined path
      // through `resolveCliAssetPath`. `root()` only existence-checks the
      // extension directory, so a template reached via `../` (shared payloads
      // under `<kindSegment>/_shared/`) would otherwise silently read from a
      // stale `dist/assets` tree that predates the shared file.
      const joined = path.join(kindSegment, id, relativePath)
      const normalized = path.normalize(joined).split(path.sep)
      return fs.readFileSync(resolveCliAssetPath('adapters', 'next', ...normalized), 'utf-8')
    }
  }
}
